"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var __1 = require("../../..");

var Button_1 = tslib_1.__importDefault(require("../../../Buttons/Button"));

var TextButton_1 = tslib_1.__importDefault(require("../../../Buttons/TextButton"));

var PriceInfo_1 = tslib_1.__importDefault(require("../../PriceInfo"));

var styles = tslib_1.__importStar(require("./LodgingRoomCard.style"));

var ic_play_xs_white_svg_1 = tslib_1.__importDefault(require("../../../../assets/ic_play_xs_white.svg"));

var ic_check_md_blue_500_svg_1 = tslib_1.__importDefault(require("../../../../assets/ic_check_md_blue_500.svg"));

function LodgingRoomCard(_ref) {
  var title = _ref.title,
      minimumReservation = _ref.minimumReservation,
      imgSrc = _ref.imgSrc,
      salePrice = _ref.salePrice,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      priceCaption = _ref.priceCaption,
      capacity = _ref.capacity,
      beds = _ref.beds,
      conveniences = _ref.conveniences,
      comingSoldOut = _ref.comingSoldOut,
      originPrice = _ref.originPrice,
      discountRate = _ref.discountRate,
      hasVideo = _ref.hasVideo,
      onClick = _ref.onClick,
      onVideoClick = _ref.onVideoClick,
      onSelectButtonClick = _ref.onSelectButtonClick;
  var contentRef = react_1.useRef(null);

  var _react_1$useState = react_1.useState(false),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isSelectedState = _react_1$useState2[0],
      setSelected = _react_1$useState2[1];

  function handleClick(event) {
    onClick && onClick(event);
  }

  function handleVideoClick(event) {
    onVideoClick && onVideoClick(event);
  }

  function handleSelectButtonClick(event) {
    if (disabled) {
      return;
    }

    event && event.stopPropagation();
    onSelectButtonClick && onSelectButtonClick();
    setSelected(!isSelectedState);
  }

  react_1.useEffect(function () {
    setSelected(isSelected);
  }, [isSelected]);
  return jsx_runtime_1.jsxs("div", Object.assign({
    css: [styles.container, isSelectedState && styles.selected]
  }, {
    children: [jsx_runtime_1.jsxs("div", Object.assign({
      css: styles.info
    }, {
      children: [jsx_runtime_1.jsxs("div", Object.assign({
        css: styles.imageContainer
      }, {
        children: [jsx_runtime_1.jsx(__1.ResponsiveImage, {
          css: styles.imageWrapper,
          src: imgSrc,
          onClick: handleClick,
          alt: "room"
        }, void 0), hasVideo && jsx_runtime_1.jsxs("div", Object.assign({
          css: styles.videoContainer,
          onClick: handleVideoClick
        }, {
          children: [jsx_runtime_1.jsx("span", {
            css: styles.oval
          }, void 0), jsx_runtime_1.jsx("img", {
            css: styles.play,
            src: ic_play_xs_white_svg_1.default,
            alt: "play"
          }, void 0)]
        }), void 0)]
      }), void 0), jsx_runtime_1.jsxs("div", Object.assign({
        ref: contentRef,
        css: styles.content
      }, {
        children: [jsx_runtime_1.jsx("span", Object.assign({
          css: styles.title
        }, {
          children: title
        }), void 0), jsx_runtime_1.jsxs("div", Object.assign({
          css: styles.description
        }, {
          children: [jsx_runtime_1.jsxs("div", Object.assign({
            css: styles.detailItem
          }, {
            children: [jsx_runtime_1.jsx(__1.Icon, {
              name: "ic_person_12x12_line_gray_500",
              alt: "capacitpy"
            }, void 0), capacity]
          }), void 0), beds && jsx_runtime_1.jsxs("div", Object.assign({
            css: styles.detailItem
          }, {
            children: [jsx_runtime_1.jsx(__1.Icon, {
              name: "ic_bed_12x12_line_gray_500"
            }, void 0), beds]
          }), void 0), jsx_runtime_1.jsxs("div", Object.assign({
            css: styles.detailItem
          }, {
            children: [jsx_runtime_1.jsx(__1.Icon, {
              name: "ic_checkcircle_12x12_line_gray_500"
            }, void 0), minimumReservation]
          }), void 0), conveniences && jsx_runtime_1.jsxs("div", Object.assign({
            css: styles.detailItem
          }, {
            children: [jsx_runtime_1.jsx(__1.Icon, {
              name: "ic_spa_12x12_line_gray_500",
              alt: "toilet"
            }, void 0), conveniences]
          }), void 0), comingSoldOut && jsx_runtime_1.jsx("div", Object.assign({
            css: styles.comingSoldOut
          }, {
            children: "\uD310\uB9E4 \uC644\uB8CC \uC784\uBC15!"
          }), void 0), jsx_runtime_1.jsx(TextButton_1.default, Object.assign({
            css: styles.moreInfo,
            size: "medium",
            onClick: handleClick
          }, {
            children: "\uAC1D\uC2E4 \uC815\uBCF4 \uB354 \uBCF4\uAE30"
          }), void 0)]
        }), void 0)]
      }), void 0)]
    }), void 0), jsx_runtime_1.jsxs("div", Object.assign({
      css: styles.priceAndButton
    }, {
      children: [jsx_runtime_1.jsx("div", Object.assign({
        css: styles.priceDetail
      }, {
        children: jsx_runtime_1.jsx(PriceInfo_1.default, {
          disabled: disabled,
          salePrice: salePrice,
          originPrice: originPrice,
          discountRate: discountRate,
          caption: priceCaption
        }, void 0)
      }), void 0), jsx_runtime_1.jsx(Button_1.default, Object.assign({
        css: styles.buttonWrapper,
        type: "secondary",
        size: "medium",
        onClick: handleSelectButtonClick,
        disabled: disabled
      }, {
        children: isSelectedState ? jsx_runtime_1.jsx("img", {
          src: ic_check_md_blue_500_svg_1.default,
          alt: "room check"
        }, void 0) : '선택'
      }), void 0)]
    }), void 0)]
  }), void 0);
}

exports.default = LodgingRoomCard;